import React from 'react'

function Edit() {
  return (
    <div>Message Type Edit</div>
  )
}

export default Edit;